import { formatMoney } from '../../utils/formatters'

export default function RevenueSplitCard({ active = false, count, label, value }) {
  return (
    <div
      className={`flex min-h-[68px] items-center justify-between rounded-md bg-[#FBFAF8] px-4 ${
        active ? 'border-l-4 border-[#8A6819]' : ''
      }`}
    >
      <div>
        <p className="text-base font-bold text-[#1A1A1A]">{label}</p>
        <p className="text-sm font-medium text-[#5A5147]">{count} Atendimentos</p>
      </div>
      <strong className={`text-lg font-bold ${active ? 'text-[#8A6819]' : 'text-[#5A5147]'}`}>
        {formatMoney(value)}
      </strong>
    </div>
  )
}
